/* eslint-disable no-param-reassign */

import axios from 'axios';
import catchify from 'catchify';

import { getCSRFCookie } from '~/util/global';

const buildApiRequest = (axiosInstance = axios, url, method = 'get', data = {}) => (
  catchify(axiosInstance({
    data,
    url,
    method,
    withCredentials: true,
    headers: {
      'X-CSRFToken': getCSRFCookie(),
    },
  }))
);

const initialState = () => ({
  plusErrorMsg: '',
  refundReason: {},
  supportSuccess: false,
});

export const mutations = {
  setRefundReason(state, refundReason) {
    state.refundReason = refundReason;
  },
  setPlusErrorMsg(state, plusErrorMsg) {
    state.plusErrorMsg = plusErrorMsg;
  },
  setSupportSuccess(state, supportSuccess) {
    state.supportSuccess = supportSuccess;
  },
};

export const getters = {
  plusErrorMsg: (state) => state.plusErrorMsg,
  refundReason: (state) => state.refundReason,
  supportSuccess: (state) => state.supportSuccess,
};

export const actions = {
  // eslint-disable-next-line consistent-return
  async sendRefundReason({ state }) {
    const { refundReason } = state;

    if (refundReason && Object.keys(refundReason).length) {
      const data = new FormData();
      data.append('refund_reason', refundReason.refund_reason);
      data.append('invoice_item', refundReason.invoice_item);
      data.append('feedback', refundReason.feedback);
      // send refund reason
      const [error] = await buildApiRequest(this.$axios, '/api/cart/refund-response/', 'post', data);

      if (error) {
        // eslint-disable-next-line no-console
        console.log('error sending refund reason', error);
      }
    }
  },
  async addPlusToCart({ commit }) {
    const [error, res] = await buildApiRequest(this.$axios, '/api/plus-info/');

    if (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to get Plus details', error);
      commit('setPlusErrorMsg', 'Failed to get Plus details');
      return;
    }
    const { id, planId } = res.data;

    const data = new FormData();
    data.append('id', id);
    data.append('plan_id', planId);

    const [err] = await buildApiRequest(this.$axios, '/cart/add/', 'post', data);
    if (err) {
      commit('setPlusErrorMsg', 'Failed to add Plus to cart');
    }
  },
  async sendSupportMessage({ commit }, { uuid, supportMessage }) {
    commit('setSupportSuccess', false);

    if (supportMessage) {
      const data = new FormData();
      data.append('subject', 'Issue with a product');
      data.append('message', supportMessage);
      data.append('uuid', uuid);

      const [err] = await buildApiRequest(this.$axios, '/api/helpscout/create_ticket/', 'post', data);

      if (err) {
        // eslint-disable-next-line no-console
        console.error('error sending support ticket: ', err);
      } else {
        commit('setSupportSuccess', true);
      }
    }
  },
};

export { initialState as state };
